import type { FreelancerDiplomasInformationPageLocales } from '../types';

const freelancerDiplomasInformationPageLocales: FreelancerDiplomasInformationPageLocales =
  {
    addDiploma: 'Voeg diploma toe',
    confirmRemoveDiploma: 'Ja, verwijder diploma',
    deleteDiplomaMessage:
      'Weet je zeker dat je {{diplomaName}} wilt verwijderen? Mocht je een vergissing maken, dan kan je het diploma handmatig weer toevoegen.',
    diplomaDeleted: 'Diploma succesvol verwijderd',
    helperMessage:
      'Voeg hieronder je diploma’s toe. Voeg alsjeblieft alleen diploma’s toe die relevant zijn voor kinderopvang.',
    removeDiploma: 'Diploma verwijderen',
    title: "Diploma's",
    wantToContinue: 'Weet je zeker dat je dit document wilt verwijderen?',
  };

export default freelancerDiplomasInformationPageLocales;
